// Multivariate Dependencies
import React from 'react';
// Components
import { AvatarIcon } from './components/AvatarIcon';
import { EzyVetImageIcon } from './components/EzyVetImageIcon';
import { FontIcon } from './components/FontIcon';
import { ImageIcon } from './components/ImageIcon';
/**
 * @deprecated Do not use legacy components anymore.
 */
var Icon = function (_a) {
    var alt = _a.alt, icon = _a.icon;
    var iconType = typeof icon;
    if (typeof icon === 'string' && icon.includes('.')) {
        var stringIcon = icon;
        if (stringIcon.includes('/')) {
            return React.createElement(ImageIcon, { alt: alt, icon: stringIcon });
        }
        return React.createElement(EzyVetImageIcon, { alt: alt, icon: stringIcon });
    }
    if (iconType === 'function') {
        var IconComponent = icon;
        return React.createElement(IconComponent, { alt: alt });
    }
    if (iconType === 'object' && !Array.isArray(icon)) {
        var avatarIcon = icon;
        return React.createElement(AvatarIcon, { alt: alt, icon: avatarIcon });
    }
    var fontIcon = icon;
    return React.createElement(FontIcon, { icon: fontIcon, alt: alt });
};
Icon.defaultProps = {
    icon: 'cancel.png',
    alt: '',
};
export default Icon;
//# sourceMappingURL=Icon.js.map